import { render, staticRenderFns } from "./DropFileV2.vue?vue&type=template&id=489f5c85&scoped=true"
import script from "./DropFileV2.vue?vue&type=script&lang=js"
export * from "./DropFileV2.vue?vue&type=script&lang=js"
import style0 from "./DropFileV2.vue?vue&type=style&index=0&id=489f5c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489f5c85",
  null
  
)

export default component.exports